import { envConfig } from 'config';
import request from 'utils/request';

const API_BASE_URL = `${envConfig.API_BASE}/api`;

// ============ v2 endpoints ============

export function getApplicationsRequest(options = {}) {
  return request(`${API_BASE_URL}/v2/applications`, {
    method: 'GET',
    ...options,
  });
}

export function createApplicationRequest({ gbmPodId, clientId, app, displayName, type }, options = {}) {
  const body = {
    gbm_pod_id: gbmPodId,
    client_id: clientId,
    app,
    type,
    display_name: displayName,
  };

  return request(`${API_BASE_URL}/v2/applications`, {
    method: 'POST',
    body,
    ...options,
  });
}

export function updateApplicationRequest(id, { displayName }, options = {}) {
  return request(`${API_BASE_URL}/v2/applications/${id}`, {
    method: 'PUT',
    body: {
      display_name: displayName,
    },
    ...options,
  });
}

export function deleteApplicationRequest(id, options = {}) {
  return request(`${API_BASE_URL}/v2/applications/${id}`, {
    method: 'DELETE',
    ...options,
  });
}

export function getUsersByRoleRequest(applicationId, role, options = {}) {
  return request(`${API_BASE_URL}/v2/applications/${applicationId}/users?role=${encodeURIComponent(role)}`, {
    method: 'GET',
    ...options,
  });
}

export function getApplicationRolesRequest(applicationId, options = {}) {
  return request(`${API_BASE_URL}/v2/applications/${applicationId}/roles`, {
    method: 'GET',
    ...options,
  });
}

export function getApplicationPermissionsRequest(applicationId, options = {}) {
  return request(`${API_BASE_URL}/v2/applications/${applicationId}/permissions`, {
    method: 'GET',
    ...options,
  });
}
